/**
 * 学习乐园 · 连连看题材包：英语单词（lianliankan/pack-yinghan.js）
 * ---------------------------------------------------------------------------
 * 关联型配对：英文连中文（「book」连「书」）。选 3~6 字母高频词——牌面字号
 * 按长度分档，太长的词在 6×6 盘上太小看不清。note 省略：消除反馈本身就是
 * 「英文连中文」的完整读法，再挂例句反而稀释（栏目「即时且可解释」口径）。
 * 24 对备 18 对/局，每局组合不同。
 */
(function (global) {
  'use strict';
  var PACKS = global.STLLK_PACKS = global.STLLK_PACKS || {};

  PACKS.yinghan = {
    id: 'yinghan',
    name: '英语单词',
    hint: '英文连中文，配对记单词',
    kind: 'rel',
    cols: 6,
    rows: 6,
    pairs: [
      { l: 'cat', r: '猫' },
      { l: 'dog', r: '狗' },
      { l: 'sun', r: '太阳' },
      { l: 'moon', r: '月亮' },
      { l: 'star', r: '星星' },
      { l: 'tree', r: '树' },
      { l: 'fish', r: '鱼' },
      { l: 'bird', r: '鸟' },
      { l: 'milk', r: '牛奶' },
      { l: 'rice', r: '米饭' },
      { l: 'egg', r: '鸡蛋' },
      { l: 'red', r: '红色' },
      { l: 'blue', r: '蓝色' },
      { l: 'hand', r: '手' },
      { l: 'foot', r: '脚' },
      { l: 'door', r: '门' },
      { l: 'water', r: '水' },
      { l: 'fire', r: '火' },
      { l: 'rain', r: '雨' },
      { l: 'snow', r: '雪' },
      { l: 'day', r: '白天' },
      { l: 'night', r: '夜晚' },
      { l: 'apple', r: '苹果' },
      { l: 'book', r: '书' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
